import clsx from 'clsx';
import React from 'react';

import { EmailEntry } from '@/src/components/project/Inbox2/types';

import AccountLink from '../../../components/AccountLink/AccountLink';

type HeaderProps = {
  emailEntry: EmailEntry;
  isResizeEnabled?: boolean;
  projectName: string;
  projectId: string;
};

const Header = ({ emailEntry, projectId, projectName }: HeaderProps) => {
  return (
    <div
      className={clsx(
        'container--emailThreadHeader',
        'tw-sticky tw-top-[1px] tw-z-[2] tw-bg-white',
        'tw-w-full',
        'tw-flex tw-justify-between',
        'tw-shadow-[0px_0px_2px_0px_rgba(65,74,79,0.30)]',
        'tw-rounded-[5px]',
        'tw-p-[10px] tw-mb-[10px]'
      )}
    >
      <div className={clsx('tw-flex tw-items-center')}>
        <p className={clsx('tw-text-cfo-black tw-text-[18px] tw-font-brandonTextMedium')}>
          {emailEntry.subject}
        </p>
        <AccountLink projectName={projectName} projectId={projectId} />
      </div>
    </div>
  );
};

export default Header;
